// extracted by mini-css-extract-plugin
export var deleteModal = "_kx-0";